import { styled } from '@mui/material/styles';

import type { Opportunity } from '../../shared/opportunity';
import { estimateFrom, travelLabel } from './estimate';
import type { TravelTimes } from './travelTimes';
import { eventPoint, type TravelCity } from './walkshed';

/**
 * "· 25 min by transit", after the neighborhood on a card or ticket. The
 * isochrone itself is only ever drawn on the map; this line is all the list
 * says about distance. The minutes are the filter's own (`TravelTimes`).
 */

const Note = styled('span')({
  flexShrink: 0,
  fontWeight: 600,
  letterSpacing: 'normal',
  color: 'rgba(54,47,42,0.7)',
  whiteSpace: 'nowrap',
  '&::before': { content: '"·"', marginRight: 6, opacity: 0.6 },
});

export function travelNote(times: TravelTimes | null, event: Opportunity, city: TravelCity | null) {
  if (!times || !city) return null;
  const t = estimateFrom(times, event);
  if (!t) return null;
  const label = travelLabel(t);
  // Measured to the neighborhood, not the door: said on hover, not on the card.
  const centroid = eventPoint(event, city)?.approximate;
  return <Note title={centroid ? `${label}, to the neighborhood's centre` : label}>{label}</Note>;
}
